import { component, prop } from '../../../decorators';

import Ellipsis from '../../common/ellipsis/ellipsis.vue';

import { scrollIntoViewIfNeeded } from '../../common/utils';

@component({
   components: { Ellipsis },
   watch: {
      selectedClip: 'onChangeSelected'
   }
})
export default class RelatedClips {
   @prop({ type: Array, required: true }) clips
   @prop({ }) selectedClip

   onChangeSelected() {
      this.$nextTick(() => {
         const idx = this.clips.indexOf(this.selectedClip);
         scrollIntoViewIfNeeded(this.$el.children[idx]);
      });
   }
}

